var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product"},[_c('div',{staticClass:"floor"},[_c('div',{staticClass:"wrapper-teacher"},[_c('div',{staticClass:"btn",on:{"click":_vm.loginTeacherWeb}},[_vm._v("老师端网页登录")])])]),_c('div',{staticClass:"floor"}),_vm._m(0),_c('div',{staticClass:"floor"})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floor"},[_c('div',{staticClass:"wrapper"})])
}]

export { render, staticRenderFns }